// extracted by mini-css-extract-plugin
export default {"mb1":"SetCountryStatusModalContainer_mb1__1sozO","middle-section":"SetCountryStatusModalContainer_middle-section__RgDEb"};